import { render, staticRenderFns } from "./premium-nyan.vue?vue&type=template&id=a8c755bc&scoped=true"
import script from "./premium-nyan.vue?vue&type=script&lang=js"
export * from "./premium-nyan.vue?vue&type=script&lang=js"
import style0 from "./premium-nyan.vue?vue&type=style&index=0&id=a8c755bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c755bc",
  null
  
)

export default component.exports